module.exports = "## Batch image resize\r\n\r\nUpload multiple photos from the upload box above to start resizing them. You can resize all your photos as a percentage of the original size or specify exact width and height."


//////////////////
// WEBPACK FOOTER
// ./src/containers/BulkResize/batch-image-resize.md
// module id = 1133
// module chunks = 0